module.exports = __webpack_public_path__ + "static/img/satellite.170d251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/satellite.png
// module id = gngc
// module chunks = 2